import calendarSlice from '@redux/slices/calendar';
import chatSlice from '@redux/slices/chat';
import kanbanSlice from '@redux/slices/kanban';
import mailSlice from '@redux/slices/mail';
import productSlice from '@redux/slices/product';
import bannerSlice from '@store/features/banner/slice';
import bookingSlice from '@store/features/booking/slice';
import doctorSlice from '@store/features/doctor/slice';
import faqSlice from '@store/features/faq/slice';
import patientSlice from '@store/features/patient/slice';
import paymentSlice from '@store/features/payment/slice';
import reduxModalSlice from '@store/features/modal/slice';
import resourceSlice from '@store/features/resource/slice';
import scheduleSlice from '@store/features/schedule/slice';
import serviceSlice from '@store/features/service/slice';
import serviceObjectSlice from '@store/features/service_object/slice';
import subjectSlice from '@store/features/subject/slice';
import telemedSlice from '@store/features/telemedicine/slice';
import totalSlice from '@store/features/total/slice';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  [productSlice.name]: productSlice.reducer,
  [mailSlice.name]: mailSlice.reducer,
  [chatSlice.name]: chatSlice.reducer,
  [kanbanSlice.name]: kanbanSlice.reducer,
  [calendarSlice.name]: calendarSlice.reducer,
  [bookingSlice.name]: bookingSlice.reducer,
  [bannerSlice.name]: bannerSlice.reducer,
  [resourceSlice.name]: resourceSlice.reducer,
  [serviceSlice.name]: serviceSlice.reducer,
  [scheduleSlice.name]: scheduleSlice.reducer,
  [patientSlice.name]: patientSlice.reducer,
  [doctorSlice.name]: doctorSlice.reducer,
  [paymentSlice.name]: paymentSlice.reducer,
  [faqSlice.name]: faqSlice.reducer,
  [totalSlice.name]: totalSlice.reducer,
  [telemedSlice.name]: telemedSlice.reducer,
  [reduxModalSlice.name]: reduxModalSlice.reducer,
  [subjectSlice.name]: subjectSlice.reducer,
  [serviceObjectSlice.name]: serviceObjectSlice.reducer,
});

export const actions = {
  ...scheduleSlice.actions,
  ...patientSlice.actions,
  ...resourceSlice.actions,
  ...doctorSlice.actions,
  ...bookingSlice.actions,
  ...paymentSlice.actions,
  ...faqSlice.actions,
  ...totalSlice.actions,
  ...telemedSlice.actions,
  ...reduxModalSlice.actions,
  ...subjectSlice.actions,
  ...bannerSlice.actions,
  ...serviceSlice.actions,
  ...serviceObjectSlice.actions,
};

export default rootReducer;
